import { get, put, post, del} from '../../../actions'

export const GET_ORGANISATIONS_REQUEST = '@@groups/GET_ORGANISATIONS_REQUEST'
export const GET_ORGANISATIONS_SUCCESS = '@@groups/GET_ORGANISATIONS_SUCCESS' 
export const GET_ORGANISATIONS_FAILURE = '@@groups/GET_ORGANISATIONS_FAILURE'
export const getOrganisations = (endpoint) =>(
    get({
        displayName: 'get organisations',
        endpoint: endpoint,
        types: [
            GET_ORGANISATIONS_REQUEST, 
            GET_ORGANISATIONS_SUCCESS, 
            GET_ORGANISATIONS_FAILURE
        ]
    })
)

export const UPDATE_ORGANISATION_REQUEST = '@@roles/UPDATE_ORGANISATION_REQUEST' 
export const UPDATE_ORGANISATION_SUCCESS = '@@roles/UPDATE_ORGANISATION_SUCCESS'
export const UPDATE_ORGANISATION_FAILURE = '@@roles/UPDATE_ORGANISATION_FAILURE'
export const updateOrganisation = ( endpoint, organisation ) => (
    put({
        displayName: 'update organisation',
        endpoint: endpoint,
        types: [
            UPDATE_ORGANISATION_REQUEST,
            UPDATE_ORGANISATION_SUCCESS,
            UPDATE_ORGANISATION_FAILURE,
        ],
        body: JSON.stringify(organisation)
    })
)

const defaultOrganisation = {
    name:'New Organisation',
}

export const CREATE_ORGANISATION_REQUEST = '@@roles/CREATE_ORGANISATION_REQUEST'
export const CREATE_ORGANISATION_SUCCESS = '@@roles/CREATE_ORGANISATION_SUCCESS'
export const CREATE_ORGANISATION_FAILURE = '@@roles/CREATE_ORGANISATION_FAILURE'
export const createOrganisation = (endpoint, organisation = defaultOrganisation ) => (
    post({
        displayName: 'create organisation',
        endpoint: endpoint,
        types: [
            CREATE_ORGANISATION_REQUEST,
            CREATE_ORGANISATION_SUCCESS,
            CREATE_ORGANISATION_FAILURE,
        ],
        body: JSON.stringify(organisation)
    })
)

export const DELETE_ORGANISATION_REQUEST = '@@roles/DELETE_ORGANISATION_REQUEST'
export const DELETE_ORGANISATION_SUCCESS = '@@roles/DELETE_ORGANISATION_SUCCESS'
export const DELETE_ORGANISATION_FAILURE = '@@roles/DELETE_ORGANISATION_FAILURE'
export const deleteOrganisation = ( endpoint ) => (
    del({
        displayName: 'delete organisation',
        endpoint: endpoint,
        types: [
            DELETE_ORGANISATION_REQUEST,
            DELETE_ORGANISATION_SUCCESS,
            DELETE_ORGANISATION_FAILURE,
        ],
    })
) 


// WEBPACK FOOTER //
// ./src/App/Admin/Organisations/actions.js